// custom typefaces
import 'typeface-montserrat'
import 'typeface-merriweather'

import { wrapRootElement as wrap } from './wrap-root-element'
import 'prismjs/themes/prism-okaidia.css'

export const wrapRootElement = wrap
